<template>
    <div class="card modal-card">
      <header class="card-header">
        <p class="card-header-title">
          История финансов {{ username }}
        </p>
      </header>
      <div class="card-content">
         <b-table :data='log' :striped='true' :narrowed='true' :hoverable='true' :paginated='true' :per-page='10' default-sort='created' default-sort-direction='desc'>
            <template slot-scope="props">
                <b-table-column field='created' label="Время" width="180" sortable >
                  {{ new Date(props.row.created).toLocaleString()  }}
                </b-table-column>
                <b-table-column field='message.action' label='Операция' width='60' sortable >
                  <span v-if='props.row.message.action === "+"'>пополнение</span>
                  <span v-if='props.row.message.action === "-"'>списание</span>
                  <span v-if='props.row.message.action === "c"'>коррекция</span>
                </b-table-column>
                <b-table-column field='message.summ' label='Сумма' width='60' numeric sortable>
                  {{ props.row.message.summ }}
                </b-table-column>
                <b-table-column label='Комментарии'>
                  {{ props.row.message.comments }}
                </b-table-column>
            </template>
         </b-table>
      </div>
    </div>
</template>

<script>
export default {
  props: ['username'],
  data: function () {
    this.username = this.$parent.$parent.selected_user.username // dirty hack, replace later
    this.fetch_data()
    return {
      log: []
    }
  },
  methods: {
    fetch_data: function () {
      var _this = this
      var form = JSON.stringify({method: 'admin_get_user_finance_history', params: {username: _this.username}})
      window.$.post(window.gw + 'api/finance', {data: form}, function (r) {
        var d = JSON.parse(r)
        if (d.result === 'ok') {
          // ok
          _this.log = d.params.history
        } else {
          // error
        }
      })
    }
  }
}
</script>

<style scoped>
    .modal-card {
        /* width: 80%; */
    }
</style>


// WEBPACK FOOTER //
// src/components/FinanceLog.vue